export const DynamicAppInputFocusState = "focus";

const APP_INPUT_BORDER_COLOR = { source: "theme.border", value: "dark" };
const APP_INPUT_BORDER_WIDTH = "standard";
const APP_INPUT_BORDER_RADIUS = "large";

export const APP_INPUT_BORDER_COLOR_DEFAULTS = {
  default: APP_INPUT_BORDER_COLOR,
  hover: APP_INPUT_BORDER_COLOR,
};

export const APP_INPUT_BORDER_WIDTH_DEFAULTS = {
  default: APP_INPUT_BORDER_WIDTH,
  hover: APP_INPUT_BORDER_WIDTH,
};

export const APP_INPUT_BORDER_RADIUS_DEFAULTS = {
  "default.border-radius": APP_INPUT_BORDER_RADIUS,
  "hover.border-radius": APP_INPUT_BORDER_RADIUS,
};
